var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2, _path9, _path10, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinReward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4581_179064)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8464 0.427043L24.3956 2.20349C25.0404 2.44279 25.5919 2.86754 26.023 3.4188L30.9426 9.4016C31.5839 10.1775 31.9415 11.1905 31.9073 12.2049L31.6653 21.5537C31.6447 22.5975 31.2348 23.5701 30.5288 24.2862L25.9913 28.9353C25.5395 29.4279 24.9477 29.7706 24.3178 29.9525L19.1017 31.4888L18.8464 0.427043Z",
    fill: "url(#paint0_linear_4581_179064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6103 0.39816L10.0674 1.21322C9.2274 1.17045 8.41823 1.50589 7.84614 2.12494L2.22359 8.84102C1.72639 9.39006 1.42572 10.1343 1.41485 10.8883L1.24992 19.2387C1.23906 19.9927 1.518 20.7564 2.00566 21.3531L7.38744 29.1213C7.94512 29.7929 8.7299 30.182 9.59933 30.2112L18.1551 31.6016C18.9951 31.6444 19.8042 31.309 20.3763 30.6899L26.9665 23.6727C27.4637 23.1237 27.7779 22.4089 27.7752 21.6255L27.9408 11.099C27.9517 10.3451 27.6728 9.58131 27.1851 8.98463L20.8222 1.48807C20.251 0.78703 19.4662 0.397946 18.6103 0.39816Z",
    fill: "url(#paint1_linear_4581_179064)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.919 4.09793L10.6023 4.71227C9.97973 4.67681 9.39036 4.94712 8.95454 5.39667L4.81007 10.4362C4.43319 10.8587 4.21228 11.388 4.19278 11.9676L4.05556 18.201C4.03606 18.7806 4.24987 19.3245 4.5975 19.7714L8.56659 25.5482C8.97072 26.0405 9.57005 26.3363 10.1791 26.3423L16.4987 27.3673C17.1213 27.4028 17.7106 27.1325 18.1465 26.6829L23.0228 21.4504C23.3996 21.0279 23.6206 20.4986 23.6401 19.919L23.7744 12.0463C23.7939 11.4666 23.5801 10.9227 23.2325 10.4758L18.5315 4.89204C18.1115 4.4427 17.5416 4.13339 16.919 4.09793Z",
    fill: "#F08F3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4581_179064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 20,
    height: 24
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.919 4.09988L10.6023 4.71422C9.97973 4.67876 9.39036 4.94907 8.95454 5.39862L4.81007 10.4381C4.43319 10.8606 4.21228 11.39 4.19278 11.9696L4.05556 18.2029C4.03606 18.7825 4.24987 19.3265 4.5975 19.7734L8.56659 25.5501C8.97072 26.0424 9.57005 26.3382 10.1791 26.3442L16.4987 27.3693C17.1213 27.4047 17.7106 27.1344 18.1465 26.6849L23.0228 21.4524C23.3996 21.0299 23.6206 20.5005 23.6401 19.9209L23.7744 12.0482C23.7939 11.4686 23.5801 10.9247 23.2325 10.4777L18.5315 4.89399C18.1115 4.44465 17.5416 4.13534 16.919 4.09988Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4581_179064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.6153 4.14187L12.2986 4.75621C11.676 4.72075 11.0867 4.99106 10.6508 5.44062L6.50637 10.4801C6.12948 10.9026 5.90857 11.432 5.88906 12.0116L5.75185 18.2449C5.73235 18.8245 5.94615 19.3685 6.29379 19.8154L10.2629 25.5921C10.667 26.0844 11.2663 26.3802 11.8754 26.3862L18.195 27.4113C18.8176 27.4467 19.4069 27.1764 19.8428 26.7268L24.719 21.4944C25.0959 21.0719 25.3168 20.5425 25.3364 19.9629L25.4707 12.0902C25.4902 11.5106 25.2764 10.9666 24.9288 10.5197L20.2278 4.93598C19.8237 4.44365 19.2379 4.17732 18.6153 4.14187Z",
    fill: "#FFA42F"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8708 22.733L13.4628 23.1597L17.2562 8.72249L20.4888 10.9493C20.7443 11.1174 20.9543 11.3421 21.0895 11.6368C21.4298 12.3011 21.7752 13.6763 20.9727 15.9704C20.4278 17.5043 18.9867 19.8059 17.7603 21.3314C17.3491 21.9124 16.5277 22.6101 15.8708 22.733Z",
    fill: "#F08F3B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.1292 10.132C12.6307 6.95672 18.6052 8.3183 19.8732 11.1608C21.6118 15.1071 16.0535 23.3631 13.2462 23.1526C10.9891 22.9751 5.67317 13.2507 9.1292 10.132Z",
    fill: "url(#paint2_linear_4581_179064)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7768 12.4799C10.3912 12.728 10.1322 13.0965 10.1041 13.5017C10.0551 14.0949 10.1978 15.0281 11.2296 16.2669C13.0292 18.4019 13.7431 15.2925 13.5463 14.2414C13.2107 12.5763 12.1986 11.6138 10.7768 12.4799Z",
    fill: "#E17E3B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4581_179064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 12,
    width: 4,
    height: 5
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7768 12.4799C10.3912 12.728 10.1322 13.0965 10.1041 13.5017C10.0551 14.0949 10.1978 15.0281 11.2296 16.2669C13.0292 18.4019 13.7431 15.2925 13.5463 14.2414C13.2107 12.5763 12.1986 11.6138 10.7768 12.4799Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4581_179064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4058 12.7615C11.0203 13.0097 10.7613 13.3781 10.7332 13.7834C10.6842 14.3765 10.8269 15.3097 11.8587 16.5485C13.6582 18.6836 14.3721 15.5741 14.1754 14.523C13.8262 12.8284 12.8571 11.8819 11.4058 12.7615Z",
    fill: "#F8902C"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5587 13.5834C18.8425 14.2022 18.8182 14.9267 18.3934 15.4782C18.03 15.9302 17.4469 16.4473 16.3565 16.9474C13.4981 18.2584 14.4256 14.837 15.1683 13.89C16.3358 12.3915 17.7454 11.8877 18.5587 13.5834Z",
    fill: "#E27A36"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4581_179064",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 12,
    width: 5,
    height: 6
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5587 13.5834C18.8425 14.2022 18.8182 14.9267 18.3934 15.4782C18.03 15.9302 17.4469 16.4473 16.3565 16.9474C13.4981 18.2584 14.4256 14.837 15.1683 13.89C16.3358 12.3915 17.7454 11.8877 18.5587 13.5834Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4581_179064)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0695 13.9193C19.3533 14.5382 19.3289 15.2627 18.9042 15.8142C18.5408 16.2661 17.9576 16.7833 16.8673 17.2833C14.0088 18.5943 14.9364 15.1729 15.6791 14.2259C16.8465 12.7275 18.2266 12.2372 19.0695 13.9193Z",
    fill: "#F8902C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4581_179064",
    x1: 23.9382,
    y1: 24.283,
    x2: 26.2684,
    y2: 6.00906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#E48818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4383,
    stopColor: "#E48A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5891,
    stopColor: "#E6911E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6966,
    stopColor: "#E99C27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783,
    stopColor: "#ECAD34"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8296,
    stopColor: "#EFBA3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.843,
    stopColor: "#EEB839"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8845,
    stopColor: "#ECB632"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBB530"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4581_179064",
    x1: 6.69598,
    y1: 29.0838,
    x2: 21.4828,
    y2: 5.0111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#FFBF20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4599,
    stopColor: "#FABF36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7859,
    stopColor: "#FAD64D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE95F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4581_179064",
    x1: 8.80538,
    y1: 17.1627,
    x2: 20.5855,
    y2: 13.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0196,
    stopColor: "#FACA4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3908,
    stopColor: "#FACD4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7089,
    stopColor: "#FAD855"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAE95F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4581_179064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinReward);
export default __webpack_public_path__ + "static/media/coin_reward.95f3a207fc08ba80837e21a34c68571e.svg";
export { ForwardRef as ReactComponent };